import { action, computed, observable, runInAction } from "mobx";

import { unique } from "@bps/common-utils";
import { DateTime } from "@bps/date-time";
import { UserAvailabilityDto } from "@libs/gateways/booking/BookingGateway.dtos.ts";

export class UserAvailability {
  @observable.ref
  dto: UserAvailabilityDto;

  constructor(dto: UserAvailabilityDto) {
    runInAction(() => {
      this.dto = dto;
    });
  }

  @action
  updateFromDto(dto: UserAvailabilityDto) {
    this.dto = dto;
  }

  @computed
  get userId() {
    return this.dto.userId;
  }

  @computed
  get schedules() {
    return this.dto.bookingSchedules ?? [];
  }

  @computed
  get availableOrgUnitIds() {
    return unique([
      ...this.dto.bookingSchedules.map(x => x.orgUnitId),
      ...this.scheduleOverrides
        .filter(
          x => x.isAvailable && DateTime.fromISO(x.endDate) >= DateTime.today()
        )
        .map(x => x.orgUnitId)
    ]);
  }

  @computed
  get scheduleOverrides() {
    return this.dto.bookingScheduleOverrides ?? [];
  }
}
